import { Card, CardContent, CardHeader, Grid, MenuItem, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import FormSelect from "../forms/form-select/FormSelect";


export default function GraphingDefaultsCard() {

    const { t } = useTranslation();
    const theme = useTheme();


    return (
        <Card
            raised={true}
            sx={{
                flex: "0 0 auto",
                margin: theme.spacing(1),
                padding: theme.spacing(2),
                marginTop: 4
            }}
        >
            <CardHeader
                    sx={{
                        padding: 1
                    }}
                    title={t('profile.graphingAndReporting')}
                     slotProps={{
                         title: { 
                            sx: {
                                fontWeight: "bold", 
                            },
                            variant: 'h5', 
                        }
                     }}
                />
            <CardContent
                sx={{
                    padding: 1,
                    paddingBottom: theme => `${theme.spacing(1)} !important`
                }}
            >

                <Grid container spacing={2}>

                    <Grid size={{ xs: 12 }}>
                        <Typography sx={{
                            fontWeight: 'bold'
                        }}>
                            {t('profile.graphing')}
                        </Typography>

                    <FormSelect
                        name="graphTooltip"
                        id="dataTooltip"
                        label={t('profile.dataTooltip.label')}
                        sx={{ width: '90%' }}
                    >
                        <MenuItem value={0}>
                            {t('profile.dataTooltip.shared')}
                        </MenuItem>
                        <MenuItem value={1}>
                            {t('profile.dataTooltip.separate')}
                        </MenuItem>
                    </FormSelect>

                    </Grid>



                    <Grid size={{ xs: 12 }}>

                    <FormSelect
                        name="graphsInViewPort"
                        id="graphsInViewPort"
                        label={t('profile.defaultStackedView.label')}
                        sx={{ width: '90%' }}
                    >
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((o, ndx) => 
                            <MenuItem key={ndx} value={o}>
                                {o}
                            </MenuItem>

                        )}
                    </FormSelect>
                    </Grid>

                    <Grid size={{ xs: 12}}>

                        <Typography sx={{
                            fontWeight: 'bold'
                        }}>
                            {t('profile.marketingReport')}
                        </Typography>

                        <FormSelect
                            name="sortDates"
                            id="sortdates"
                            label={t('profile.sortDates.label')}
                            sx={{ width: '90%' }}
                        >
                            <MenuItem value={1}>
                                {t('profile.sortDates.left')}
                            </MenuItem>
                            <MenuItem value={2}>
                                {t('profile.sortDates.right')}
                            </MenuItem>
                        </FormSelect>                        
                    </Grid>


                    
                </Grid>

           </CardContent>
        </Card>
    );
}